"use client";

import { Button, notification } from "antd";
import React, { useEffect } from "react";
import { IconErrorSvg } from "./Iconsvg";
import Logo from "../../theme/images/logo_oseo_valais_retina.png";
import { useRouteError } from "react-router-dom";
import { storeNew } from "../../store/store.new";
import { http } from "../api/http";
import {getLogoByCustomer} from "../customerConfig";

export function Fallback({ error, resetErrorBoundary }) {
  // Call resetErrorBoundary() to reset the error boundary and retry the render.

  const isDev = process.env.NODE_ENV === "development";

  return (
    <div>
      <div>
        <div className="error-fallback" style={{ marginTop: 50 }}>
          <img src={getLogoByCustomer()} className={"login-logo"} />
          <br />
          <h3>Oupss.. Une erreur est survenue.</h3>
          {isDev && (
            <>
              <h4>Error Stack:</h4>
              <pre>{error.stack}</pre>
            </>
          )}
          <br />
          <Button
            size={"large"}
            type={"primary"}
            onClick={() => {
              window.location.href = "/";
            }}
            style={{ marginBottom: 20 }}
          >
            Revenir à l'accueil
          </Button>
          <br />
          <IconErrorSvg />
        </div>
      </div>
    </div>
  );
}

export const ErrorElement = ({}) => {
  const error = useRouteError();

  useEffect(() => {
    logError();
  }, []);

  const logError = async () => {
    try {
      const state = storeNew.getState();

      const currentURL = window.location.href;

      const errorLog = {
        stack: error.stack,
        state: state,
        baseUrl: currentURL,
      };

      let sender = await http.post("/errors", errorLog);

      notification.error({
        message:
          "Navré du dérangement, nous allons traiter votre erreur au plus vite.",
      });
    } catch (e) {
      console.log(e);
    }
  };

  return <Fallback error={error} />;
};
